import { Carousel } from './Carousel';
import { Grid } from './Grid';
import { List } from './List';
import { Masonry } from './Masonry';

export const variations = {
  grid: Grid,
  masonry: Masonry,
  list: List,
  carousel: Carousel
};
